import { InfiniteCarousel, PartnerLogo } from './InfiniteCarousel'

// Default partner logos
const defaultPartnerLogos: PartnerLogo[] = [
  { src: "/assets/images/2020/04/the-cedar-shop.png", alt: "Cedar Shop Partner", width: 250 },
  { src: "/assets/images/2020/04/timbertown.png", alt: "Timbertown Partner", width: 250 },
  { src: "/assets/images/2021/02/mclean.png", alt: "McLean Railings", width: 250 },
  { src: "/assets/images/2021/02/azek.jpg", alt: "Azek Partner", width: 250 },
  { src: "/assets/images/2020/timbertech-logo.jpg", alt: "TimberTech Partner", width: 250 },
  { src: "/assets/images/2020/03/fiberon.jpg", alt: "Fiberon Partner", width: 250 },
  { src: "/assets/images/2020/03/trex.jpg", alt: "Trex Partner", width: 250 }
]

interface AssociationsAndSuppliersProps {
  title?: string
  logos?: PartnerLogo[]
  defaultLogoWidth?: number
  backgroundColor?: string
  className?: string
}

export function AssociationsAndSuppliers({
  title = "Associations and Suppliers",
  logos = defaultPartnerLogos,
  defaultLogoWidth = 200,
  backgroundColor = "bg-white",
  className = ""
}: AssociationsAndSuppliersProps) {
  return (
    <section className={`py-10 overflow-hidden ${backgroundColor} ${className}`}>
      <h2 className="text-5xl md:text-6xl mb-8 text-center font-script text-text-dark">
        {title}
      </h2>
      
      <InfiniteCarousel 
        logos={logos} 
        defaultLogoWidth={defaultLogoWidth}
      />
    </section>
  )
} 